type AsteriskProps = {
  size?: number;
  color?: string;
  pinkCenter?: boolean;
  className?: string;
  style?: React.CSSProperties;
};

// Official Evoke Advisory asterisk mark — five organic blades, asymmetric,
// hand-drawn quality. Path traced from media/logo asterisk artwork.
const ASTERISK_PATH =
  "M -18.76 -95.00 L 3.37 -15.99 L 4.69 -11.66 L 4.93 -11.54 L 59.65 -78.28 L 85.14 -50.63 L 85.14 -50.39 L 73.59 -42.57 L 12.99 -2.04 L 13.47 -1.56 L 93.20 29.94 L 92.23 32.11 L 74.80 62.05 L 73.72 61.57 L 6.97 8.66 L 6.61 8.78 L 6.25 14.19 L 1.32 95.00 L -35.47 87.78 L -35.84 87.66 L -35.59 86.94 L -5.77 6.49 L -88.39 27.30 L -89.47 27.54 L -89.71 27.30 L -93.32 -9.50 L -93.08 -9.98 L -12.27 -6.37 L -6.85 -6.37 L -53.27 -79.61 L -19.00 -94.88 Z";

export function Asterisk({
  size = 32,
  color = "currentColor",
  pinkCenter = false,
  className = "",
  style,
}: AsteriskProps) {
  // Suppress the pink dot on large decorative renders — reads as a misprint at scale.
  const showDot = pinkCenter && size < 120;
  return (
    <svg
      viewBox="-100 -100 200 200"
      width={size}
      height={size}
      className={className}
      style={style}
      aria-hidden="true"
    >
      <path d={ASTERISK_PATH} fill={color} />
      {showDot && <circle cx="0" cy="0" r="9" fill="var(--pink)" />}
    </svg>
  );
}
